(() => {
  const root = document.getElementById('tfc-survey-popup');

  if (!root) return;

  const params = new URLSearchParams(window.location.search);
  const isTestMode = params.get('survey_popup_test') === '1';
  const testOnly = root.dataset.testOnly === 'true';
  const designMode = root.dataset.designMode === 'true';
  const pageType = root.dataset.pageType || '';
  const closeSuppressionDays = Number(root.dataset.closeSuppressionDays || 14);
  const clickSuppressionDays = Number(root.dataset.clickSuppressionDays || 90);
  const mobileDelayMs = Number(root.dataset.mobileDelayMs || 35000);
  const cartDelayMs = Number(root.dataset.cartDelayMs || 25000);
  const closeButtons = root.querySelectorAll('[data-tfc-survey-close]');
  const cta = root.querySelector('[data-tfc-survey-cta]');
  const dialog = root.querySelector('.tfc-survey-popup__dialog');

  const storageKeys = {
    dismissedUntil: 'tfcSurveyPopupDismissedUntil',
    clickedUntil: 'tfcSurveyPopupClickedUntil'
  };

  let hasOpened = false;
  let previousFocus = null;

  const now = () => Date.now();

  const daysToMs = (days) => days * 24 * 60 * 60 * 1000;

  const getStoredTime = (key) => {
    try {
      return Number(localStorage.getItem(key) || 0);
    } catch (error) {
      return 0;
    }
  };

  const setStoredTime = (key, value) => {
    try {
      localStorage.setItem(key, String(value));
    } catch (error) {}
  };

  const isSuppressed = () => {
    return getStoredTime(storageKeys.dismissedUntil) > now() || getStoredTime(storageKeys.clickedUntil) > now();
  };

  const isEligiblePage = () => {
    if (isTestMode) return true;

    const path = window.location.pathname.toLowerCase();

    return pageType === 'product' || pageType === 'cart' || path === '/cart' || path.startsWith('/products/');
  };

  const shouldRun = () => {
    if (designMode && !isTestMode) return false;
    if (testOnly && !isTestMode) return false;
    if (!isEligiblePage()) return false;
    if (isSuppressed()) return false;

    return true;
  };

  const openPopup = () => {
    if (hasOpened || !shouldRun()) return;

    hasOpened = true;
    previousFocus = document.activeElement;

    root.hidden = false;
    document.body.classList.add('tfc-survey-popup-is-open');

    window.setTimeout(() => {
      if (dialog) dialog.focus();
    }, 0);
  };

  const closePopup = () => {
    root.hidden = true;
    document.body.classList.remove('tfc-survey-popup-is-open');
    setStoredTime(storageKeys.dismissedUntil, now() + daysToMs(closeSuppressionDays));

    if (previousFocus && typeof previousFocus.focus === 'function') {
      previousFocus.focus();
    }
  };

  const handleCtaClick = () => {
    setStoredTime(storageKeys.clickedUntil, now() + daysToMs(clickSuppressionDays));
  };

  const handleExitIntent = (event) => {
    if (event.clientY <= 8) {
      openPopup();
      document.removeEventListener('mouseout', handleExitIntent);
    }
  };

  const isDesktopPointer = () => {
    return window.matchMedia('(min-width: 750px) and (pointer: fine)').matches;
  };

  const startTriggers = () => {
    if (isTestMode) {
      window.setTimeout(openPopup, 700);
      return;
    }

    if (isDesktopPointer()) {
      document.addEventListener('mouseout', handleExitIntent);
      return;
    }

    const delay = pageType === 'cart' ? cartDelayMs : mobileDelayMs;
    window.setTimeout(openPopup, delay);
  };

  closeButtons.forEach((button) => {
    button.addEventListener('click', closePopup);
  });

  if (cta) {
    cta.addEventListener('click', handleCtaClick);
  }

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !root.hidden) {
      closePopup();
    }
  });

  if (shouldRun()) {
    startTriggers();
  }
})();